/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetRealizedPnlSettlementsOptions,
  GetRealizedPnlSettlementsResponses,
} from '../types/GetRealizedPnlSettlements'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get realized P&L settlements with filters
 * {@link /v1/realized_pnl_settlements}
 */
export function getRealizedPnlSettlements<ThrowOnError extends boolean = true>(
  options: Options<GetRealizedPnlSettlementsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetRealizedPnlSettlementsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/realized_pnl_settlements',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetRealizedPnlSettlementsResponses, ThrowOnError>>,
  )
}
